module.exports = __webpack_public_path__ + "img/pages-jaunes.png";